import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "toggleIcon"]

  expand() {
    this.detailsTarget.classList.remove("hidden")
    this.toggleIconTarget.classList.add("rotate-180")
  }

  collapse() {
    this.detailsTarget.classList.add("hidden")
    this.toggleIconTarget.classList.remove("rotate-180")
  }

  toggle() {
    if (this.detailsTarget.classList.contains("hidden")) {
      this.expand()
    } else {
      this.collapse()
    }
  }
}
